var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledCevronUp = function SvgCircledCevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 62 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31 62c17.12 0 31-13.88 31-31S48.12 0 31 0 0 13.88 0 31s13.88 31 31 31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.843 40.439a2.55 2.55 0 0 0 3.58-.325l10.76-12.91 10.761 12.91a2.541 2.541 0 1 0 3.903-3.258l-12.71-15.253a2.543 2.543 0 0 0-3.9 0L16.52 36.857a2.545 2.545 0 0 0 .323 3.582"
  })));
};
export default SvgCircledCevronUp;